require("!!/usr/src/cube/node_modules/script-loader/addScript.js")(require("!!/usr/src/cube/node_modules/raw-loader/index.js!/usr/src/cube/src/legacy/floors/category-intro/category-intro.legacy.js"))


//////////////////
// WEBPACK FOOTER
// ./src/legacy/floors/category-intro/category-intro.legacy.js
// module id = 708
// module chunks = 31